import "core-js";
import 'regenerator-runtime/runtime';
import { isSupported } from 'azure-maps-control';
import bp from './core/bp.js';
import styling from './core/styling.js';
import { createDiv, getRequired } from './core/domMan';

import Playlist from './engines/sequential-playlist.js';
import spinnerCctr, { wrapperName as spinnerWrapperName } from './components/spinner.js';
import cctr from './complete/mainMap';

var match = document.cookie.match(new RegExp('(^| )' + 'mapstyle' + '=([^;]+)'));
if (match) {
    const style = match[2];

    if (style === 'night') {
        document.body.classList.add('st-night');
    }
}

const { controlPanel, mapContainer } = cctr();
const { titleBar, statusBar } = controlPanel;


const spinnerWrapper = createDiv(mapContainer, { id: spinnerWrapperName });
const spinner = spinnerCctr(spinnerWrapper);

const mapEndpointDom = getRequired('mapStructEndpoint');
let mapStructEndpoint = mapEndpointDom.value;
if (!mapStructEndpoint) {
    throw new Error("No 'mapStructEndpoint' value supplied");
}

const retryAfterMs = 60 * 1000;

const setFailed = (message, footerMessage, retry = false) => {
    spinner.hide();
    titleBar.setSubTitle(message);
    statusBar.setStatus(footerMessage ?? 'Please try again later');
    const children = titleBar.titleBar.children;
    styling.hide(Array.from(children));
    styling.show([titleBar.titleBar, titleBar.subTitle]);

    if (retry) {
        setTimeout(() => document.location.reload(), retryAfterMs);
    }
};

if (isSupported(true)) {
    bp.FetchJson(mapStructEndpoint).then(playlistConfig => {
        const { views } = playlistConfig;
        const names = [];
        const loadPromises = [];
        views.forEach(view => {
            let { engine: presetName } = view;
            names.push(presetName);
            const loadPromise = import(`./engines/${presetName}/${presetName}.js`);
            loadPromises.push(loadPromise);
        });

        Promise.all(loadPromises).then(loadedPresets => {
            views.forEach((view, index) => {
                const materializedPreset = loadedPresets[index];
                view.engine = materializedPreset.default;
            });
        }).then(async () => {
            playlistConfig.skipBaseInit = true;
            playlistConfig.autoPlay = true;
            const playlist = new Playlist(playlistConfig);
            await playlist.execute();

            const { reloadAfterMinutes, identifier } = playlistConfig;
            if (reloadAfterMinutes > 0) {
                const seconds = reloadAfterMinutes * 60;
                const msSeconds = 1000 * seconds;
                setTimeout(() => document.location.reload(), msSeconds);
            }

            const urlSegments = mapStructEndpoint.split('/');
            const originalId = urlSegments[3];
            if (originalId && originalId !== identifier) {
                const mappingCheckInterval = setInterval(() => {
                    bp.FetchJson(`/api/device-dashboard/${originalId}`).then(result => {
                        if (result.dashboardId !== identifier) {
                            clearInterval(mappingCheckInterval);
                            document.location.reload();
                        }
                    }, () => { });
                }, 30 * 1000);
            }

        });
    }, error => {
        const unknownIdentifier = error?.status === 404;
        setFailed(
            'Playlist fetch failed.',
            unknownIdentifier ? 'Please try another identifier' : 'Retrying in a minute...',
            !unknownIdentifier);
    });
}
else {
    setFailed('Current browser is not supported', 'Please use newer browser with GL support.');
}
